import React from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import RemoveControl from 'components/remove_control';

export default function ToggleControl({ isToggledOn, ...props }) {
  const Component = isToggledOn ? RemoveControl : AddControl;
  return <Component {...props} />;
}

ToggleControl.propTypes = {
  isToggledOn: PropTypes.bool,
};
